import { useTranslation } from 'react-i18next';

import { Form, FormGenerator } from '@/shared/ui';
import { FormFieldValues } from '@/shared/ui/FormGenerator';

import { changeEmailSchema } from '../model/schemas';
import { ChangeEmailFormDataType } from '../model/types';

type TChangeEmailForm = {
  id: string;
  onSubmit: (data: ChangeEmailFormDataType) => Promise<void>;
};

export const ChangeEmailForm = ({ id, onSubmit }: TChangeEmailForm) => {
  const { t } = useTranslation();

  const formScheme = [
    {
      name: 'email',
      label: t('common:inputs.email'),
      type: FormFieldValues.Email,
      inputProps: {
        autoFocus: true,
      },
    },
    {
      name: 'currentPassword',
      label: t('common:inputs.currentPassword'),
      type: FormFieldValues.Password,
    },
  ];

  return (
    <Form
      id={id}
      onSubmit={onSubmit}
      defaultValues={{
        email: '',
        currentPassword: '',
      }}
      mode="onChange"
      sx={{ width: '400px' }}
      schema={changeEmailSchema(t)}
      noValidate
    >
      <FormGenerator formScheme={formScheme} />
    </Form>
  );
};
